<template>
    <div class="kb-desktop-header">
        <div class="kb-desktop-header__top">
            <div class="kb-desktop-header__logo">
                <a href="/">
                    <kb-base-logo-l></kb-base-logo-l>
                </a>
            </div>
            <div class="kb-desktop-header__search">
                    <kb-recipe-search-input placeholder="Rezept suchen" :suggest-limit=5 :target-host="searchTargetHost"></kb-recipe-search-input>
            </div>
        </div>
        <div class="kb-desktop-header__navbar">
            <kb-desktop-navigation-items :items="navigationItems" :profile-items="profileNavigationItems" :recipe-upload-url="recipeUploadUrl"></kb-desktop-navigation-items>
        </div>
    </div>
</template>

<script>
import BaseLogoL from '@/components/Atoms/BaseLogoL/BaseLogoL'
import DesktopNavigationItems from '@/components/Molecules/DesktopNavigationItems/DesktopNavigationItems'
import RecipeSearchInput from '@/components/Molecules/RecipeSearchInput/RecipeSearchInput'
export default {
    name: 'kb-desktop-header',
    props: {
        searchTargetHost: {
            type: String
        },
        navigationItems: {
            required: true,
            type: Array
        },
        profileNavigationItems: {
            required: true,
            type: Array
        },
        recipeUploadUrl: {
            required: true,
            type: String
        }
    },
    components: {
        BaseLogoL,
        DesktopNavigationItems,
        RecipeSearchInput
    },
    data: function() {
        return {
        }
    }
}
</script>

<style lang="scss" scoped>

.kb-desktop-header {
    position: relative;
    z-index: 1000;
    box-sizing: border-box;
    width: 100%;
    background-color: $cBGPrimary;
    margin-top: 15px;

    &__top {
        display: flex;
    }

    &__logo,
    &__search {
        flex-grow: 1;
        flex-shrink: 0;
    }

    &__logo {
        padding-left: 1rem;
        padding-bottom: 2px;
    }

    &__navbar {
        width:100%;
    }
}

</style>